import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import { authStoreIdSelector } from 'state/auth/selectors';

import { Button, ButtonColor } from 'components/Button/Button';
import { Endpoint } from 'Endpoint';
import { makeUrl } from 'core/utils/utils';
import i18n from '../../../../i18n';
import { Link } from 'react-router-dom';

const useStyles = makeStyles(() => ({
    downloadButtonText: {
        color: 'inherit',
    },
}));

interface IStickerDownloadButtonProps {
    className?: string;
    buttonColor?: ButtonColor;
    storeId?: string;
}

export const StickerDownloadButton: FC<IStickerDownloadButtonProps> = ({ className, buttonColor, storeId }) => {
    const classes = useStyles();
    const authStoreId = useSelector(authStoreIdSelector);
    const storeIdToUse = storeId ? storeId : authStoreId;
    const { t } = i18n.useTranslation();
    const linkTo = makeUrl(Endpoint.VENDOR_GET_ALL_MARKETING_DOCS, { storeId: storeIdToUse });

    return (
        <Button className={className} color={buttonColor ? buttonColor : ButtonColor.DARK}>
            <Link to={linkTo} target="_blank" rel="noopener noreferrer" className={classes.downloadButtonText}>
                {t('vendor:dashboard:marketingWidget:button')}
            </Link>
        </Button>
    );
};
